import { render, staticRenderFns } from "./WholesaleCustomers.vue?vue&type=template&id=7a12701c&"
import script from "./WholesaleCustomers.vue?vue&type=script&lang=ts&"
export * from "./WholesaleCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports